import omit from "lodash/omit";

import { ChatComponent as Chat } from "@/components/pieces/chat/ChatComponent";
import { getUser } from "@/components/session/JwtTokenManager";
import { useDirectMessageQuery } from "@/graphql";
import { DirectMessageUser } from "@/types/users";

import { ChatSection } from "./ChatSection";

interface DirectMessageProps {
  assignmentId: string;
  backLinkTo?: string;
  canChat: boolean;
}

export function DirectMessage({
  assignmentId,
  backLinkTo,
  canChat,
}: DirectMessageProps) {
  const user = getUser();
  const { loading, data } = useDirectMessageQuery({
    variables: { assignmentId },
  });

  const assignment = data?.assignment;
  const channelId = assignment?.chatChannelId ?? `DM_${assignmentId}`;
  const isCoach = assignment?.coach?.id === user?.id;

  const customer: DirectMessageUser = {
    __typename: "MiniUserType",
    ...omit(assignment?.customer, "__typename"),
    isAgent: isCoach,
  };

  const channelName = assignment
    ? isCoach
      ? assignment.customer?.name
      : assignment.coach?.name
    : "Loading";

  function ChatComponent({ height }: { height: number }) {
    return (
      <Chat channelId={channelId} height={height} customerId={customer.id} />
    );
  }

  return (
    <ChatSection
      loading={loading}
      canChat={canChat}
      channelName={channelName}
      backLinkTo={backLinkTo}
      user={customer}
      ChatComponent={ChatComponent}
    />
  );
}
